import gsap from 'gsap/all'
import Component from '../classes/Component'

export default class extends Component {
  constructor ({ element, elements }) {
    super({
      classes: {},
      element: element,
      elements: {
        inner: (elements && elements.inner) || 'picture'
      }
    })

    this.create()
  }

  create () {
    gsap.fromTo(this.elements.inner, {
      translate: '-7rem'
    }, {
      translateY: '7rem',
      ease: 'none',
      scrollTrigger: {
        trigger: this.element,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    })
  }
}
